import { createSlice } from "@reduxjs/toolkit";
import {
  getWarehouses,
  addWarehouse,
  updateWarehouse,
  deleteWarehouse,
} from "./warehouse.actions";

const initialState = {
  warehouse: null,
  warehouses: null,
  total: 0,
  loading: false,
  isEditing: false,
};

export const warehouseSlice = createSlice({
  name: "warehouse",
  initialState,
  reducers: {
    setWarehouse: (state, action) => {
      const warehouse = state.warehouses.find(
        (_warehouse) => _warehouse.id === action.payload
      );
      state.warehouse = warehouse;
    },
    setIsEditing: (state, action) => {
      state.isEditing = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getWarehouses.pending, (state) => {
        state.loading = true;
      })
      .addCase(getWarehouses.fulfilled, (state, action) => {
        state.loading = false;
        state.warehouses = action.payload.data;
        state.total = action.payload.count;
      })
      .addCase(getWarehouses.rejected, (state) => {
        state.loading = false;
      });
    builder
      .addCase(addWarehouse.pending, (state) => {
        state.loading = true;
      })
      .addCase(addWarehouse.fulfilled, (state, action) => {
        state.loading = false;
        window.location.hash = "#/profile/warehouse";
      })
      .addCase(addWarehouse.rejected, (state) => {
        state.loading = false;
      });
    builder
      .addCase(updateWarehouse.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateWarehouse.fulfilled, (state, action) => {
        state.loading = false;
        state.isEditing = false;
        state.warehouse = action.payload;
      })
      .addCase(updateWarehouse.rejected, (state) => {
        state.loading = false;
      });
    builder
      .addCase(deleteWarehouse.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteWarehouse.fulfilled, (state) => {
        state.loading = false;
        window.location.hash = "#/profile/warehouse";
      })
      .addCase(deleteWarehouse.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setWarehouse, setIsEditing } = warehouseSlice.actions;

export default warehouseSlice.reducer;
